import { ProducerAuthLink, ProducerAuthLinkResponse } from '@/@types/MembersArea';
import { api } from './api';

async function authenticateProducer(): Promise<ProducerAuthLink> {
  const response = await api.post<ProducerAuthLinkResponse>(
    '/v1/member-area/produtor/auth'
  );

  return response.data.data;
}

export const MembersAreaService = {
  authenticateProducer,
};
